'use client';

import { GetProductAction } from '../../types/cmsProduct';
import { ComponentProductMetadata, VerticalType } from '../../types/cmsTypes';
import { PushDataLayerFn } from '../../types/pushDataLayer';
import { CmsClientVerticalScope } from '../../utils/cmsPageContext/CmsClientVerticalScope';
import { AsideModal } from '../AsideModal';
import { ProductAsideModal } from '../ProductAsideModal';
import { useProductBlockAsideModal } from './useProductBlockAsideModal';

export const ProductBlockAsideModal = (props: {
  vertical?: VerticalType;
  isPreview?: boolean;
  getProductAction: GetProductAction;
  tableConfig: ComponentProductMetadata | undefined;
  pushDataLayer: PushDataLayerFn;
}) => {
  const {
    closeModal,
    modalProductUrlAlias,
    modalProductIdScrollTo,
    modalProductVertical,
  } = useProductBlockAsideModal();
  const vertical = modalProductVertical ?? props.vertical;

  return (
    <AsideModal isOpen={!!modalProductUrlAlias} onClose={closeModal}>
      <CmsClientVerticalScope vertical={vertical}>
        <ProductAsideModal
          vertical={vertical!}
          url_alias={modalProductUrlAlias ?? ''}
          id_scroll_to={modalProductIdScrollTo ?? null}
          isPreview={props.isPreview}
          getProductAction={props.getProductAction}
          tableConfig={props.tableConfig}
          pushDataLayer={props.pushDataLayer}
        />
      </CmsClientVerticalScope>
    </AsideModal>
  );
};

export default ProductBlockAsideModal;
